import { lazyRouteComponent } from '@tanstack/react-router';

export const profilePageLoadable = lazyRouteComponent(() =>
  import('../../ui/profile-page').then((m) => ({ default: m.ProfilePage })),
);
